import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  personaCard: {
    width: "48%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    alignItems: "flex-start",
    alignContent: "flex-start"
  },
  personaImage: {
    backgroundColor: "#000",
    width: "100%",
    objectFit: "contain",
    objectPosition: "left top"
  },
  personaTextContainer: {
    width: "100%",
    marginTop: "10pt"
  },
  presonaText: {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "14pt",
    color: "#8b99bd"
  }
});
